import { fetchRepositories } from '../api';
import { postApi } from '../api/digitalVault';
export default async (logger) => {
    const { repositories: { repository }, } = await fetchRepositories(logger);
    const request = [];
    (Array.isArray(repository) ? repository : [repository]).forEach(({ uri, trashUsage }) => {
        const data = new URLSearchParams();
        data.append('uri', uri.$);
        request.push(data);
    });
    return Promise.all(request.map(async (data) => {
        await postApi(data, 'uri/trash/purge', {}, logger);
    }));
};
